import { render } from "./fitterMapPlaceholder.vue?vue&type=template&id=18f88f56"
import script from "./fitterMapPlaceholder.vue?vue&type=script&lang=js"
export * from "./fitterMapPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__